<template>
  <ContentCard title="常见问题" rightTitle="更多" @rightClick="goMore">
    <InfoList :list="list" @detail="openNoticePage"></InfoList>
  </ContentCard>
</template>

<script>
import { noticeGetPaged } from '@/api/siteserver'
import { getFilter1 } from '@/utils/config'
import ContentCard from '@/components/ContentCard'
import InfoList from '@/components/InfoList'

export default {
	name: "SystemNotice",
  components: { ContentCard, InfoList },
  data() {
    return {
      list: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      try {
        let filter = getFilter1('常见问题首页')
        const { result, success } = await noticeGetPaged({
          filter,
          order: 'createdDate desc',
          pageNum: 1,
          pageSize: 10
        })
        if(success && result.totalCount) this.list = result.items
      } catch(e) {
        console.log(e)
      }
    },
    openNoticePage(item) {
			this.$router.push({ path: '/infoDetail', query: { cId: item.id }})
		},
    goMore() {
      store.set('nType', '常见问题')
      this.$router.push({ name: 'helpCenter' })
    }
  }
};
</script>

<style lang="less" scoped>
.noData {
  text-align: center;
}
</style>
